module.exports = __webpack_public_path__ + "media/images/emblems/Oberegg-Wappen-b119e6680cdde766200dd811f2a71c07.png";